export enum CompatibilityType {
  AndroidWebView = 'ANDROID_WEB_VIEW',
  Unsupported = 'UNSUPPORTED',
}
